/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreatePushNotificationTokenDto } from '../models/work-create-push-notification-token-dto';
import { WorkSuccessDto } from '../models/work-success-dto';

@Injectable({ providedIn: 'root' })
export class WorkPushNotificationTokensService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `pushNotificationTokensV1ControllerRegister()` */
  static readonly PushNotificationTokensV1ControllerRegisterPath = '/v1/push-notification-tokens';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pushNotificationTokensV1ControllerRegister()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pushNotificationTokensV1ControllerRegister$Response(
    params: {
      body: WorkCreatePushNotificationTokenDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkPushNotificationTokensService.PushNotificationTokensV1ControllerRegisterPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pushNotificationTokensV1ControllerRegister$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pushNotificationTokensV1ControllerRegister(
    params: {
      body: WorkCreatePushNotificationTokenDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.pushNotificationTokensV1ControllerRegister$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

}
